import { nullish } from "components/OptionsWizard/WizardContext";
import { ICADLayer } from "../../interfaces";

export const GridLayerIcon: React.FC<{ layer: ICADLayer | nullish }> = ({ layer }) => {

    if (!layer)
        return <></>;

    return <div style={{
        width: "32px",
        height: "32px",
        padding: "2.5px",
    }}>
        <svg width="27" height="27" viewBox="0 0 20 20">
            <rect x="0" y="0" width="20" height="20" rx="3" ry="3" fill="blue" stroke="black" strokeWidth="1" />
            <line x1="7" y1="1" x2="7" y2="19" stroke="white" strokeWidth="1" />
            <line x1="13" y1="1" x2="13" y2="19" stroke="white" strokeWidth="1" />
            <line x1="1" y1="7" x2="19" y2="7" stroke="white" strokeWidth="1" />
            <line x1="1" y1="13" x2="19" y2="13" stroke="white" strokeWidth="1" />
        </svg>

    </div>

}